module.exports = __webpack_public_path__ + "img/logo-kelloggs.b6b02a4e.png";